import produce from 'immer'
import { AiStepSchema } from '@feedyou-ai/feedbot-schema'

import { GetUsedDialogs } from '../../../types'

export const getUsedDialogs: GetUsedDialogs<AiStepSchema> = (
  { disabled, tools = [] },
  enabledOnly = false
) => {
  if (enabledOnly && disabled) {
    return []
  }

  return produce([] as string[], result => {
    tools.forEach(tool => {
      if (tool.action?.dialog && Boolean(!enabledOnly || !tool.disabled)) {
        result.push(tool.action.dialog)
      }
    })
  })
}
